import { Typography } from "antd";
import { ReactNode } from "react";

export default function ExternalCalculatorLayout({
  children,
  headerRight,
}: {
  children?: ReactNode;
  headerLeft?: ReactNode;
  headerRight?: ReactNode;
}) {
  return (
    <div>
      <div className="flex w-full justify-between items-center gap-3 h-[50px] border border-solid border-gray-300 px-6">
        <Typography.Title level={5} className="!m-0">
          Calculator
        </Typography.Title>
        {headerRight}
      </div>
      <div>{children}</div>
    </div>
  );
}
